import React from 'react';

import { Navigate } from 'react-router-dom';

import { UserPermissions } from '@/features/permissions';
import { Pages } from '@/pages';

const SupplierPortfolioHistoryLayout = React.lazy(() => import('./index'));
const ImportsHistory = React.lazy(() => import('./views/ImportsHistory'));
const PortfolioCompare = React.lazy(() => import('./views/PortfolioCompare'));
const SupplierPortfolioImportDetails = React.lazy(
  () => import('@/pages/SupplierPortfolioImportDetails'),
);

const supplierPortfolioHistoryRoute = [
  {
    element: <SupplierPortfolioHistoryLayout />,
    handle: {
      permissions: UserPermissions.OrganizationsSupplierPortfolioRead,
    },
    children: [
      {
        path: Pages.SUPPLIER_PORTFOLIO_HISTORY,
        element: (
          <Navigate
            to={`./${Pages.SUPPLIER_PORTFOLIO_HISTORY_IMPORTS_PART}`}
            relative='path'
            replace
          />
        ),
      },
      {
        path: `${Pages.SUPPLIER_PORTFOLIO_HISTORY}/${Pages.SUPPLIER_PORTFOLIO_HISTORY_IMPORTS_PART}`,
        element: <ImportsHistory />,
      },
      {
        path: `${Pages.SUPPLIER_PORTFOLIO_HISTORY}/${Pages.SUPPLIER_PORTFOLIO_HISTORY_COMPARE_PART}`,
        element: <PortfolioCompare />,
      },
    ],
  },
  {
    path: Pages.SUPPLIER_PORTFOLIO_HISTORY_IMPORT_DETAILS,
    element: <SupplierPortfolioImportDetails fromHistory />,
    handle: {
      permissions: UserPermissions.OrganizationsSupplierPortfolioRead,
    },
  },
];

export default supplierPortfolioHistoryRoute;
